import { Standard } from "./standard.class.js";
export class GraphQLType extends Standard {
  type = "";
  fields = {};
  isRequired = false;
  isItemRequired = false;
  isList = false;
  isEnum = false;
}
